import { render, staticRenderFns } from "./MyDialog.vue?vue&type=template&id=cc647c38&scoped=true&"
import script from "./MyDialog.vue?vue&type=script&lang=js&"
export * from "./MyDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc647c38",
  null
  
)

export default component.exports